<template>
  <Page
    :loading="isLoadingPage"
    :spinning="isSpinning"
  >
    <PageTitle>Eksport</PageTitle>

    <Box>
      <div class="row middle-xs">
        <div class="col-xs-9">
          <p>Eksporter alle præparater og indholdsstoffer til en Excel-fil.</p>
        </div>
        <div class="col-xs-3">
          <BaseButton
            full
            :label="isExporting ? 'Eksporterer...' : 'Eksporter til Excel'"
            :disabled="isExporting"
            @click.prevent="exportPreparationsAndSubstances"
          />
        </div>
      </div>
    </Box>
  </Page>
</template>

<script>
import Page from './Page.vue';
import Box from '../components/Box.vue';
import BaseButton from '../components/BaseButton.vue';
import ExportService from '../services/ExportService';
import Pageload from '../mixins/Pageload';

export default {
    name: 'Export',
    mixins: [Pageload],
    components: { Page, Box, BaseButton },
    data() {
        return {
            isExporting: false,
        };
    },
    methods: {
        async exportPreparationsAndSubstances() {
            this.isExporting = true;

            try {
                const blob = await ExportService.preparationsAndSubstances();
                const fileName = `PraeparaterOgAktiveStoffer_${window.moment().format('YYYY-MM-DD')}.xlsx`;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                //
            } finally {
                this.isExporting = false;
            }
        },
    },
    created() {
        this.pageloaded();
    },
};
</script>
